/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as actiontypes from './actiontypes';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import {
  ndcDetailSingle,
  singleAccRecNDCDetail,
} from '../../AccRecNDCDetail/store/actions';
import { clearReqAccRecSearchPageDispatch } from '../../ReqAccReceivable/store/actions';
import {
  commonSearchPageOther,
  commonSearchPage,
} from '../../AccountsRevConstants';

export const arMfgTblData = (val) => {
  return { type: actiontypes.AR_MFG_TBL_DATA, payload: val };
};

export const arMfgFldData = (val) => {
  return { type: actiontypes.AR_MFG_FLD_DATA, payload: val };
};

export const arMfgFirstLoadAction = (val) => {
  return { type: actiontypes.AR_MFG_FIRST_LOAD, payload: val };
};

export const getUnallocatedMfgAr = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_UNALLOCATED_BAL_MFG}`, val)
    .then((response) => {
      dispatch({
        type: actiontypes.AR_MFG_UNALLOCATED_VAL,
        payload: response.data.unallocatedBalance,
      });
    })
    .catch((response) =>
      dispatch({ type: actiontypes.AR_MFG_UNALLOCATED_VAL, payload: null })
    );
};

export const getAccRecNDCSingleRec = (val, data) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_NDC_SGL_RPC}`, val)
    .then((response) => {
      dispatch({ type: actiontypes.AR_MFG_NDC_DETAIL, payload: response.data });
      dispatch(ndcDetailSingle(data));
      dispatch(singleAccRecNDCDetail(response.data));
    })
    .catch(() => {
      dispatch({ type: actiontypes.AR_MFG_NDC_DETAIL, payload: null });
    });
};

export const dispatchClearReduxData = (val) => {
  return { type: actiontypes.AR_MANUFACTURER_CLEAR_REDUX, payload: val };
};

export const clearARManufacturerPage = (history) => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.AccountRecReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let changePass = false;
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) => x.navTo === '/reqAccReceivable' || x.navTo === '/mfgAccountRec'
      ).length === 0
    ) {
      newObj.rbt_list = [];
      changePass = true;
    }
    newObj1 = _.cloneDeep(newObj);
  } else {
    _.mapKeys({ ...commonSearchPageOther, ...commonSearchPage }, (val, key) => {
      newObj1[key] = val;
    });

    changePass = true;
  }
  if (changePass) {
    dispatch(clearReqAccRecSearchPageDispatch(newObj1));
  }
  dispatch(dispatchClearReduxData());
};
